import React from "react";
export function ErrorFallback({ error, ...restProps }) {
  const title = error.name || "Oops!";
  const reason = error.message || "Something went wrong";

  return (
    <div status="error" {...restProps}>
      {/* <Icon/> */}
      <div>{title}</div>
      <div>{reason}</div>
    </div>
  );
}
